<template>
  <div class="card">
    <div class="card-body">
      <div class="row mb-3 align-items-end">
        <div class="col-sm-5">
          <label class="font-size-12 text-muted mb-1">Buscar</label>
          <input
            type="text"
            class="form-control"
            v-model="search"
            placeholder="Nome, e-mail ou CPF — pressione ENTER"
            @keyup.enter="reload"
          />
        </div>
        <div class="col-sm-3">
          <label class="font-size-12 text-muted mb-1">De</label>
          <input type="date" class="form-control" v-model="dateFrom" @change="reload" />
        </div>
        <div class="col-sm-2">
          <label class="font-size-12 text-muted mb-1">Até</label>
          <input type="date" class="form-control" v-model="dateTo" @change="reload" />
        </div>
        <div class="col-sm-2 text-right">
          <button class="btn btn-success btn-block" @click="exportCsv" :disabled="exporting || loading">
            <i class="bx bx-download mr-1"></i>{{ exporting ? 'Exportando...' : 'Exportar CSV' }}
          </button>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-centered table-nowrap table-hover">
          <thead>
            <tr>
              <th>Participante</th>
              <th>E-mail</th>
              <th>CPF</th>
              <th>Telefone</th>
              <th>Grupo</th>
              <th v-for="f in fields" :key="f.name">{{ f.label }}</th>
              <th>Operador</th>
              <th>Coletado em</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td :colspan="totalCols" class="text-center text-muted py-4">Carregando...</td>
            </tr>
            <tr v-else-if="rows.length === 0">
              <td :colspan="totalCols" class="text-center text-muted py-4">
                Nenhuma coleta de lead registrada.
              </td>
            </tr>
            <tr v-for="row in rows" :key="row.submission_id">
              <td>{{ row.participant.name || '—' }}</td>
              <td>{{ row.participant.email || '—' }}</td>
              <td>{{ row.participant.cpf || '—' }}</td>
              <td>{{ row.participant.phone || '—' }}</td>
              <td>{{ row.participant.group || '—' }}</td>
              <td v-for="f in fields" :key="f.name">{{ answerOf(row, f.name) }}</td>
              <td>{{ row.operator || '—' }}</td>
              <td>{{ formatDate(row.collected_at) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-right">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                @input="reload"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { listLeadCollection, exportLeadCollection } from '@/pages/reports/services'
import { errorMessage } from '@/components/alertsMessages'

export default {
  name: 'report-lead-collection',
  data () {
    return {
      loading: true,
      exporting: false,
      search: '',
      dateFrom: '',
      dateTo: '',
      rows: [],
      fields: [],
      currentPage: 1,
      perPage: 50,
      totalRows: 0
    }
  },
  computed: {
    totalCols () {
      return 7 + this.fields.length
    }
  },
  mounted () {
    this.reload()
  },
  methods: {
    params () {
      return {
        search: this.search || null,
        date_from: this.dateFrom || null,
        date_to: this.dateTo || null,
        limit: this.perPage,
        page: this.currentPage
      }
    },
    async reload () {
      this.loading = true
      try {
        const res = await listLeadCollection(this.params())
        this.fields = res.fields || []
        this.rows = res.data || []
        const pg = res.pagination || {}
        this.totalRows = pg.total || 0
        this.currentPage = pg.current_page || 1
      } catch (err) {
        errorMessage('Falha ao carregar o relatório de coleta de lead.')
      } finally {
        this.loading = false
      }
    },
    answerOf (row, name) {
      const v = row.answers && row.answers[name]
      return (v === undefined || v === null || v === '') ? '—' : v
    },
    formatDate (d) {
      return d ? this.$moment(d).format('DD/MM/YYYY HH:mm') : '—'
    },
    async exportCsv () {
      this.exporting = true
      try {
        const blob = await exportLeadCollection(this.params())
        const url = window.URL.createObjectURL(new Blob([blob]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `coleta-de-lead-${this.$moment().format('YYYYMMDD-HHmm')}.csv`)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      } catch (err) {
        errorMessage('Falha ao exportar o relatório.')
      } finally {
        this.exporting = false
      }
    }
  }
}
</script>
